import type { UUID } from "utils";

const BASE_URL = "/stablecoins";

export const PAGE_URLS = {
  onboarding: `${BASE_URL}/onboarding`,
  payments: `${BASE_URL}/payments`,
  paymentDetails: `${BASE_URL}/payments/:id`,
  getLinkToPaymentDetails: (fiatTxId: UUID) =>
    `${BASE_URL}/payments/${fiatTxId}`,
} as const;
